import { InjectionToken } from '@angular/core'
import type { Environment } from 'src/environments/environment.type'

/**
 * Build-time environment from `app.config` (main bundle).
 * Use this in lazy-loaded code instead of importing `environment` directly so
 * API URLs match the CI-injected `environment.*.ts` values.
 */
export const APP_ENVIRONMENT = new InjectionToken<Environment>('APP_ENVIRONMENT')
